import * as yup from "yup";

export const schema = yup.object().shape({
  id: yup.number().notRequired(),
  plan_id: yup.number().required(),
  cycle: yup.string().required(),
  payment_method: yup.string().notRequired(),
  payment_method_id: yup.string().notRequired(),
  name: yup.string().required().min(3).max(100),
  email: yup.string().required().min(3).max(100),
  phone: yup.string().required(),
  titular: yup.string().required(),
  coupon_identifier: yup.string().notRequired(),
  terms: yup.boolean().required(),
});
